import excelPreview from './src/main'

excelPreview.install = function (Vue) {
  Vue.component(excelPreview.name, excelPreview)
}

export default excelPreview
